import styled, { createGlobalStyle } from 'styled-components';
import { Menu, GlobalToken } from 'antd';

export const PopoverMenuUserStyled = styled(Menu)<{ $isUpdating: boolean }>`
  width: 70px;

  .user-icon {
    margin-left: -2px;
    margin-top: 3px;
    width: 32px;
    height: 32px;
  }

  ${({ $isUpdating }) =>
    $isUpdating &&
    `
    pointer-events: none;
  `}
`;

export const GlobalPopoverMenuUserStyle = createGlobalStyle<{ theme: { token: GlobalToken } }>`
  .popover-menu-user {
    width: 250px;

    .expand-icon {
      transform: rotate(-90deg);
    }

    .user-name {
      color: ${({ theme: { token } }) => token.colorText};
    }

    .user-email {
      color: ${({ theme: { token } }) => token.colorTextTertiary};
    }

    .menu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;      
    }
      
    .menu-item-content {
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${({ theme: { token } }) => token.colorText}; 

    }
  }
`;
